import { StoryData } from '@cinch-nx/data-storyblok'
import { BrandPageStory } from '../storyblok'

export const BydBrandPageFallbackStory: StoryData<BrandPageStory> = {
  name: 'BYD',
  uuid: '0081a3b3-edd7-4dc1-a0e4-5990e50b4526',
  created_at: '2025-10-15T10:00:13.509Z',
  published_at: '2025-11-19T12:26:57.792Z',
  full_slug: 'landing/byd',
  content: {
    _uid: 'dd678f42-3ac1-49d4-b4cb-56fb580d79aa',
    _editable:
      '<!--#storyblok#{"name": "LandingPage", "space": "132543", "uid": "dd678f42-3ac1-49d4-b4cb-56fb580d79aa", "id": "101715204154700"}-->',
    component: 'LandingPage',
    SEO: [
      {
        _uid: 'f2e89d06-66c1-4797-9337-9022eeccc4ca',
        HowTo: [],
        title: 'BYD | Latest BYD cars',
        robots: [],
        component: 'SEO',
        openGraph: [],
        description:
          'Explore BYD for an exciting range of new EVs and plug-in hybrids with cutting-edge tech and striking design. Learn more about BYD now.',
        twitterCard: [],
        canonicalUrl: '',
        _editable:
          '<!--#storyblok#{"name": "SEO", "space": "132543", "uid": "f2e89d06-66c1-4797-9337-9022eeccc4ca", "id": "101715204154700"}-->',
      },
    ],
    body: [
      {
        _uid: 'feabf59b-28eb-489f-9059-9ba67a7eb6f7',
        content: [
          {
            _uid: '1f9794b3-bb39-4390-b96b-69e9c3c926e7',
            text: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: 'center',
                  },
                  content: [
                    {
                      text: 'Discover a range of exciting new EVs and plug-in hybrids from BYD. Built for comfort, efficiency and performance, the BYD range boasts cutting-edge tech and striking design.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: 'center',
                  },
                  content: [
                    {
                      text: "We're partnering with Marshall Motor Group, one of the UK's leading automotive retailers, to sell brand new BYD cars. Discover more below, then shop the range and submit your enquiry – the Marshall team will be in touch to discuss how to test drive and buy.",
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            component: 'RichText',
            _editable:
              '<!--#storyblok#{"name": "RichText", "space": "132543", "uid": "1f9794b3-bb39-4390-b96b-69e9c3c926e7", "id": "101715204154700"}-->',
          },
          {
            url: '/new-cars',
            _uid: '42d70452-a958-4331-883e-0873e5b72e51',
            label: 'Buy a brand new BYD',
            component: 'CtaButton',
            _editable:
              '<!--#storyblok#{"name": "CtaButton", "space": "132543", "uid": "42d70452-a958-4331-883e-0873e5b72e51", "id": "101715204154700"}-->',
          },
        ],
        component: 'IntroSection',
        _editable:
          '<!--#storyblok#{"name": "IntroSection", "space": "132543", "uid": "feabf59b-28eb-489f-9059-9ba67a7eb6f7", "id": "101715204154700"}-->',
      },
      {
        _uid: '1e92f548-60a3-4edb-9ef9-5fc3855c69d3',
        component: 'LandingTextInlineImageSection',
        textInlineImages: [
          {
            _uid: '7a747b34-b241-470d-9cdc-286573863601',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'DOLPHIN SURF',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'The DOLPHIN SURF is BYD’s smallest car, an electric supermini bursting with character and up to 200 miles of range. Urban driving has never been so fun.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'It’s compact yet confident, offers lively performance and the smartly practical interior is packed with tech to engage you on every drive.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 106_023_567_746_800,
              alt: 'byd-dolphin-surf-2025-3',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/132543/488x391/3de77e5409/byd-dolphin-surf-2025-3.png',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'byd-dolphin-surf-2025-3',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imagePosition: 'right',
            _editable:
              '<!--#storyblok#{"name": "LandingTextInlineImage", "space": "132543", "uid": "7a747b34-b241-470d-9cdc-286573863601", "id": "101715204154700"}-->',
          },
          {
            _uid: 'f34f535d-e3f1-4d30-98bd-c1f5466b3350',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'DOLPHIN',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'The BYD DOLPHIN is a versatile electric hatchback with up to 265 miles of range and ocean-inspired styling. It’s perfect for daily commutes and city adventures alike.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Its compact design makes it brilliantly agile around the city, and the floating centre console design adds minimalist style to the comfortable interior.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 106_719_272_905_208,
              alt: 'BYD Dolphin',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/132543/488x391/8e77a9c5ff/byd-dolphin-2023-1.png',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'BYD Dolphin',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imagePosition: 'left',
            _editable:
              '<!--#storyblok#{"name": "LandingTextInlineImage", "space": "132543", "uid": "f34f535d-e3f1-4d30-98bd-c1f5466b3350", "id": "101715204154700"}-->',
          },
          {
            _uid: '841831d1-6629-44e2-8f75-adbedfecd392',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'ATTO 2',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'The BYD ATTO 2 is a compact electric crossover SUV that blends youthful energy with sharp design and offers up to 267 miles of range. There’s no better package for the city streets.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Agile, efficient and easy to drive, it’s built for urban lifestyles. Inside, intuitive tech and quality materials create a comfortable environment that’s impressively spacious.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 106_719_272_880_630,
              alt: 'Green BYD ATTO SUV',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/132543/488x391/8a7441f563/byd-atto-2-2025-5.png',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Green BYD ATTO SUV',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imagePosition: 'right',
            _editable:
              '<!--#storyblok#{"name": "LandingTextInlineImage", "space": "132543", "uid": "841831d1-6629-44e2-8f75-adbedfecd392", "id": "101715204154700"}-->',
          },
          {
            _uid: '9c525fe1-05b7-4648-a16b-522cad69033d',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'ATTO 3',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'The BYD ATTO 3 is a stylish, compact electric SUV with up to 260 miles of range that blends innovation, comfort and everyday practicality. At home wherever you need to go.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Expressive performance is paired with a playful, unique interior, creating a positive attitude that keeps up with the demands of modern living.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'From £37,705',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '',
                          },
                        },
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 106_719_272_958_458,
              alt: 'Blue BYD Atto 3 SUV',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/132543/488x391/cb1fb17a27/byd-atto-3-2023-1.png',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Blue BYD Atto 3 SUV',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imagePosition: 'left',
            _editable:
              '<!--#storyblok#{"name": "LandingTextInlineImage", "space": "132543", "uid": "9c525fe1-05b7-4648-a16b-522cad69033d", "id": "101715204154700"}-->',
          },
          {
            _uid: 'e60a3716-3d20-4546-bbea-12edad2f0802',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'SEALION 7',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'The BYD SEALION 7 is a performance electric SUV with up to 300 miles of range. Built for space, comfort and driving dynamics, it’s the do-it-all model in the line-up.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'A sweeping yet commanding fastback-style shape wraps around the premium interior – home to adaptive ambience, immersive audio and personalised comfort.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'From £47,000',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '',
                          },
                        },
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 106_719_272_888_823,
              alt: 'BYD Sealion 7',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/132543/488x391/82f9c5e239/byd-sealion-2025-3.png',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'BYD Sealion 7',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imagePosition: 'right',
            _editable:
              '<!--#storyblok#{"name": "LandingTextInlineImage", "space": "132543", "uid": "e60a3716-3d20-4546-bbea-12edad2f0802", "id": "101715204154700"}-->',
          },
          {
            _uid: 'b52532af-dba7-472b-99e2-2b73006baf1d',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'SEAL',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'The BYD SEAL is a dynamic, luxurious electric saloon with up to 345 miles of range. Combining elegant design with impressive performance, it’s the executive choice. ',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Its award-winning design is complemented by premium features, such as an immersive driving theatre and a Dynaudio sound system for ultimate driving sophistication.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'From £45,705',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '',
                          },
                        },
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 106_719_272_978_939,
              alt: 'BYD Seal',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/132543/488x391/51fbfb5fc2/byd-seal-2023-1.png',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'BYD Seal',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imagePosition: 'left',
            _editable:
              '<!--#storyblok#{"name": "LandingTextInlineImage", "space": "132543", "uid": "b52532af-dba7-472b-99e2-2b73006baf1d", "id": "101715204154700"}-->',
          },
          {
            _uid: '37cdabd1-0c32-4edf-85d5-355c7d83dd62',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'SEAL U DM-i',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'The SEAL U DM-i is BYD’s only plug-in hybrid – a futuristic full-size SUV that delivers an impressive combined range of up to 699 miles (78 miles electric-only). Perfect for all the family adventures. ',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'The smart, oceanic exterior is elegant and aerodynamic, while the iconic floating centre console and class-leading tech are found in the comfortable cabin',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'From £33,315',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '',
                          },
                        },
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 106_719_272_929_785,
              alt: 'BYD Seal U DM-i',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/132543/488x391/860b827e5e/byd-seal-u-dm-i-2024-1.png',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'BYD Seal U DM-i',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imagePosition: 'right',
            _editable:
              '<!--#storyblok#{"name": "LandingTextInlineImage", "space": "132543", "uid": "37cdabd1-0c32-4edf-85d5-355c7d83dd62", "id": "101715204154700"}-->',
          },
        ],
        _editable:
          '<!--#storyblok#{"name": "LandingTextInlineImageSection", "space": "132543", "uid": "1e92f548-60a3-4edb-9ef9-5fc3855c69d3", "id": "101715204154700"}-->',
      },
      {
        url: '/new-cars/',
        _uid: 'b4e43e3f-48ef-419c-91cc-f3e37ec14fb4',
        label: 'Shop BYD',
        component: 'CtaButton',
        _editable:
          '<!--#storyblok#{"name": "CtaButton", "space": "132543", "uid": "b4e43e3f-48ef-419c-91cc-f3e37ec14fb4", "id": "101715204154700"}-->',
      },
      {
        _uid: 'b9eada8f-8e03-479e-932d-d273e289fb48',
        title: 'Why Choose BYD',
        component: 'HighlightsSection',
        highlights: [
          {
            _uid: '49ca2099-6a14-4c6f-9878-b140eaa55eae',
            body: 'Powered by BYD’s Blade Battery for fast charging and performance',
            icon: 'range',
            title: 'Advanced Technology',
            component: 'FeatureCard',
            _editable:
              '<!--#storyblok#{"name": "FeatureCard", "space": "132543", "uid": "49ca2099-6a14-4c6f-9878-b140eaa55eae", "id": "101715204154700"}-->',
          },
          {
            _uid: 'e380d859-f520-421c-85b7-59f6718c834f',
            body: 'Engineered for efficiency, safety and a cleaner electric future',
            icon: 'co2',
            title: 'Sustainable Innovation',
            component: 'FeatureCard',
            _editable:
              '<!--#storyblok#{"name": "FeatureCard", "space": "132543", "uid": "e380d859-f520-421c-85b7-59f6718c834f", "id": "101715204154700"}-->',
          },
          {
            _uid: 'f707dcd0-2ade-4447-b767-c438d06d38e5',
            body: 'Backed by decades of leadership in EVs and battery development',
            icon: 'charge',
            title: 'Global Expertise',
            component: 'FeatureCard',
            _editable:
              '<!--#storyblok#{"name": "FeatureCard", "space": "132543", "uid": "f707dcd0-2ade-4447-b767-c438d06d38e5", "id": "101715204154700"}-->',
          },
        ],
        _editable:
          '<!--#storyblok#{"name": "HighlightsSection", "space": "132543", "uid": "b9eada8f-8e03-479e-932d-d273e289fb48", "id": "101715204154700"}-->',
      },
      {
        _uid: '1b55a9ec-24e3-41b8-8be4-5a85fef65d0c',
        title: ' BYD DOLPHIN – Agile and Versatile Electric Hatchback',
        videoId: 'G7fm9K3oQTk',
        component: 'YoutubeVideo',
        thumbnail: {
          id: null,
          alt: null,
          name: '',
          focus: null,
          title: null,
          source: null,
          filename: '',
          copyright: null,
          fieldtype: 'asset',
          meta_data: {},
        },
        description: '',
        displayHeading: false,
        _editable:
          '<!--#storyblok#{"name": "YoutubeVideo", "space": "132543", "uid": "1b55a9ec-24e3-41b8-8be4-5a85fef65d0c", "id": "101715204154700"}-->',
      },
      {
        _uid: 'f608ccef-6a20-47ad-ae03-8646e9f8ce09',
        title: 'Shop new cars',
        sortBy: '',
        priceTo: '35000',
        component: 'CarsCarousel',
        priceFrom: '10000',
        disclaimer: 'Sold by our partner Marshall Motor Group',
        carsCondition: 'new',
        showMonthlyPrices: true,
        showOnlyCinchStock: false,
        financeRepresentativeExample: [
          {
            _uid: '543fd343-6931-497f-b885-78510bcd9dec',
            component: 'FinanceRepresentativeExample',
            creditAmount: '202',
            onTheRoadPrice: '194',
            customerDeposit: '',
            retailerDiscount: '',
            representativeApr: '202',
            annualMileageLimit: '202',
            totalAmountPayable: '202',
            optionToPurchaseFee: '',
            totalInterestAmount: '202',
            optionalFinalPayment: '202',
            monthlyPaymentsAmount: '202',
            revisedOnTheRoadPrice: '',
            fixedAnnualInterestRate: '202',
            numberOfMonthlyPayments: '202',
            excessMileageChargeInPence: '202',
            financeDepositContribution: '',
            _editable:
              '<!--#storyblok#{"name": "FinanceRepresentativeExample", "space": "132543", "uid": "543fd343-6931-497f-b885-78510bcd9dec", "id": "101715204154700"}-->',
          },
        ],
        _editable:
          '<!--#storyblok#{"name": "CarsCarousel", "space": "132543", "uid": "f608ccef-6a20-47ad-ae03-8646e9f8ce09", "id": "101715204154700"}-->',
      },
      {
        _uid: '9fac571a-4642-4b7f-b8f3-3ceedb44dea4',
        faqs: [
          {
            _uid: '1fd8d071-f341-480a-86fd-d0b191648dcc',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Search our range of brand new cars, then submit our quick enquiry form and the Marshall team will call you back to discuss your purchase.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'We’re partnering with Marshall Motor Group to bring our customers brand new cars.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Marshall has over 115 years of motoring know-how and is one of the UK’s largest motor retailers, so our customers benefit from the shared experience of both brands.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            title: 'How can I buy a new car on cinch?',
            component: 'AccordionItem',
            _editable:
              '<!--#storyblok#{"name": "AccordionItem", "space": "132543", "uid": "1fd8d071-f341-480a-86fd-d0b191648dcc", "id": "101715204154700"}-->',
          },
          {
            _uid: '76d2f745-ddd2-4fdf-bff3-fae923b6c1e6',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Of course – you can test drive a new BYD at one of the Marshall BYD stores across the country.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Find the opening hours and contact details here:',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Ashford',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.marshall.co.uk/byd/contact-us/marshall-byd-ashford/',
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '#1155CC',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Canterbury',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.marshall.co.uk/byd/contact-us/marshall-byd-canterbury/',
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '#1155CC',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Maidstone',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.marshall.co.uk/byd/contact-us/marshall-byd-maidstone/',
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '#1155CC',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Northampton',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.marshall.co.uk/byd/contact-us/marshall-byd-northampton/',
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '#1155CC',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Peterborough',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.marshall.co.uk/byd/contact-us/marshall-byd-peterborough/',
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '#1155CC',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'St Neots',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.marshall.co.uk/byd/contact-us/marshall-byd-st-neots/',
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '#1155CC',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            title: 'Can I test drive a new car?',
            component: 'AccordionItem',
            _editable:
              '<!--#storyblok#{"name": "AccordionItem", "space": "132543", "uid": "76d2f745-ddd2-4fdf-bff3-fae923b6c1e6", "id": "101715204154700"}-->',
          },
          {
            _uid: 'd10d7639-b6c9-4cb3-bab6-ae0feb4bf555',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'You can pay for a new car however it suits you – buy outright or on finance (Hire Purchase or Personal Contract Purchase).',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Since your purchase is handled by Marshall Motor Group, one of the UK’s largest motor retailers, they’ll talk you through your options after you submit your enquiry.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            title: 'What are my payment options when buying a new car?',
            component: 'AccordionItem',
            _editable:
              '<!--#storyblok#{"name": "AccordionItem", "space": "132543", "uid": "d10d7639-b6c9-4cb3-bab6-ae0feb4bf555", "id": "101715204154700"}-->',
          },
          {
            _uid: 'c5846d31-4d31-4e9a-be79-62acdd22d592',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'The Marshall team will talk you through your options for delivery and/or collection – and how long they’ll take – when they call you back after your enquiry.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            title: 'How can I get my new car?',
            component: 'AccordionItem',
            _editable:
              '<!--#storyblok#{"name": "AccordionItem", "space": "132543", "uid": "c5846d31-4d31-4e9a-be79-62acdd22d592", "id": "101715204154700"}-->',
          },
        ],
        title: 'Frequently Asked Questions',
        component: 'FaqSection',
        _editable:
          '<!--#storyblok#{"name": "FaqSection", "space": "132543", "uid": "9fac571a-4642-4b7f-b8f3-3ceedb44dea4", "id": "101715204154700"}-->',
      },
    ],
    hero: [
      {
        _uid: '4d52ed7b-0e42-439d-bb45-763ecd212bf4',
        logo: {
          id: 107_115_035_263_837,
          alt: 'BYD logo white',
          name: '',
          focus: '',
          title: '',
          source: '',
          filename:
            'https://a.storyblok.com/f/132543/169x33/01b1d80411/byd-logo-svg.svg',
          copyright: '',
          fieldtype: 'asset',
          meta_data: {
            alt: 'BYD logo white',
            title: '',
            source: '',
            copyright: '',
          },
          is_external_url: false,
        },
        image: {
          id: 106_723_024_870_371,
          alt: 'byd-attos-3',
          name: '',
          focus: '',
          title: '',
          source: '',
          filename:
            'https://a.storyblok.com/f/132543/841x366/77be763418/byd-attos-3.png',
          copyright: '',
          fieldtype: 'asset',
          meta_data: {
            alt: 'byd-attos-3',
            title: '',
            source: '',
            copyright: '',
          },
          is_external_url: false,
        },
        heading: 'Drive the future with BYD',
        component: 'LandingHero',
        ctaButton: [
          {
            url: '/new-cars',
            _uid: '42cf44d6-aaf7-4b6e-b03c-5464c2c10232',
            label: 'Shop new BYD',
            component: 'HeroCtaButton',
            _editable:
              '<!--#storyblok#{"name": "HeroCtaButton", "space": "132543", "uid": "42cf44d6-aaf7-4b6e-b03c-5464c2c10232", "id": "101715204154700"}-->',
          },
        ],
        _editable:
          '<!--#storyblok#{"name": "LandingHero", "space": "132543", "uid": "4d52ed7b-0e42-439d-bb45-763ecd212bf4", "id": "101715204154700"}-->',
      },
    ],
  },
  group_id: '7c42c52e-8356-4228-96d7-ba5994b4dfb5',
  id: 101_715_204_154_700,
  is_startpage: false,
  meta_data: null,
  alternates: [],
  parent_id: 96_546_359_237_594,
  position: 10,
  first_published_at: '2025-10-15T10:00:45.388Z',
  slug: 'byd',
  lang: 'default',
  sort_by_date: null,
  tag_list: [],
  path: 'byd',
}
